import React, { useEffect, useState } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import {
  AuthorableNotification,
} from '@express-labs/raven-ui';
import s from './SlotnotificationAuthorable.scss';
import { updateClosedNotifications, getClosedNotifications } from './helpers';

function SlotNotificationAuthorable({
  hasMargin,
  currentNotifications,
}) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    setNotifications(getClosedNotifications(currentNotifications));
  }, [currentNotifications]);

  return (
    <div className={`${s.container} ${hasMargin && s.hasMargin}`}>
      {
        notifications?.map((item) => (
          <AuthorableNotification
            key={`notification-${item.uid}`}
            messageType={item.messageType}
            cta={item.cta}
            display={item.display}
            message={item.message}
            title={item.title}
            onClose={() => updateClosedNotifications({ uid: item.uid, updatedAt: item.updatedAt })}
          />
        ))
      }
    </div>
  );
}

SlotNotificationAuthorable.propTypes = {
  hasMargin: PropTypes.bool,
  currentNotifications: arrayOf(PropTypes.shape({
    uid: PropTypes.string,
    updatedAt: PropTypes.string,
  })).isRequired,
};

SlotNotificationAuthorable.defaultProps = {
  hasMargin: false,
};

export default SlotNotificationAuthorable;
